var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { randomInteger } from '../../../utils/helper/helper_math';
export class CycleBranding {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get cycle() {
        return this.parent;
    }
    get app() {
        return this.parent.app;
    }
    get doesCycleHaveABranding() {
        return !!this.brandingAnswer;
    }
    get randomBrandingIndex() {
        return randomInteger(0, 9);
    }
    get brandingAnswer() {
        if (this.app.menubar.menubarRight.isMultiPlayerMode)
            return undefined;
        if (this.app.appInfo.isPremiumApp && this.app.user.id !== 1)
            return undefined;
        if (runtime.browserRuntime && runtime.browserRuntime.browserBandwidth.isSlowConnection)
            return undefined;
        const miniBrandings = this.app.tray.funnel.funnelBranding.remainingMiniBrandingsSortedByPriority;
        if (miniBrandings.length === 0)
            return undefined;
        if (miniBrandings.length < 10)
            return this.app.tray.trayTransform.funnelMiniQuestionToAnswer(miniBrandings[0]);
        return this.app.tray.trayTransform.funnelMiniQuestionToAnswer(miniBrandings[this.randomBrandingIndex]);
    }
}
__decorate([
    memoize
], CycleBranding.prototype, "randomBrandingIndex", null);
__decorate([
    computed
], CycleBranding.prototype, "brandingAnswer", null);
